"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalListener = (function () {
    function ModalListener() {
    }
    ModalListener.listen = function () {
        this.buyTicketError();
        this.buyModal();
    };
    ModalListener.buyTicketError = function () {
        var modal = document.getElementById('buyTicketError');
        var modalClose = document.getElementById('buyTicketModalClose');
        modalClose.addEventListener('click', function () {
            modal.style.display = 'none';
            overlay.style.display = 'none';
            modal.classList.add('fade');
        });
    };
    ModalListener.buyModal = function () {
        var modal = document.getElementById('buyTicketModal');
        var overlay = document.getElementById('modalOverlay');
        overlay.addEventListener('click', function () {
            modal.style.display = 'none';
            overlay.style.display = 'none';
            modal.classList.add('fade');
        });
    };
    return ModalListener;
}());
exports.default = ModalListener;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/listeners/modals/modal.ts
// module id = 2403
// module chunks = 5